@use "../../styles/breakpoint" as *;

.root {
    background-color: var(--white);
    padding: 80px 0;

    @media ($below-tablet) {
        padding: 50px 0;
    }
}

.header {
    margin-bottom: 80px;
}

.carousel {
    composes: container from "../../styles/composable/layout.module.css";
}

.slideWrapper {
    gap: 28px;

    @media ($below-mobile) {
        gap: 0;
    }
}

.slide {
    background-color: var(--alabaster);
}

.columnContent {
    padding: 32px;
    text-align: center;
}

.dots {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 36px;

    & > button {
        appearance: none;
        background-color: transparent;
        border: 2px solid var(--ironside);
        border-radius: 8px;
        height: 15px;
        width: 15px;

        &:disabled {
            background-color: var(--ironside);
        }

        // Pure React Carousel generates dots based on number of slides.
        // Instead, we need a way to display enough dots neccessary to
        // navigate groups of slides (like Flickity) based on viewport width.
        // Below is a work-a-round that will need adjusted if visibleSlideNum
        // changes at breakpoints within the component.
        @media ($above-tablet) {
            &:nth-last-of-type(-n + 2) {
                display: none;
            }
        }

        @media ($above-mobile) and ($below-tablet) {
            &:nth-last-of-type(-n + 1) {
                display: none;
            }
        }
    }
}
